import * as api from "./client.js";

export type AuditActor = {
  type: "user" | "system" | "anonymous";
  id: string;
  source: string;
  email?: string | null;
  name?: string | null;
  tenantId?: string | null;
  firmRef?: string | null;
  isImpersonating?: boolean;
  impersonatedBy?: string | null;
  requestId?: string | null;
  ip?: string | null;
};

export type AuditEvent = {
  id: string;
  type: string;
  source: string;
  subject: string | null;
  occurredAt: string;
  actor: AuditActor | null;
  payload: unknown;
  metadata: unknown;
  provenanceState: "captured" | "legacy_missing";
};

export type AuditEventFilters = {
  actorId?: string;
  actorEmail?: string;
  actorType?: "user" | "system" | "anonymous";
  firmName?: string;
  type?: string;
  subject?: string;
  impersonatedBy?: string;
  from?: string;
  to?: string;
  provenanceState?: "captured" | "legacy_missing";
  cursor?: string;
  limit?: number;
};

export type AuditEventsResponse = {
  events: AuditEvent[];
  nextCursor: string | null;
  requestId?: string;
};

function queryString(filters: AuditEventFilters): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== "") params.set(key, String(value));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
}

export const auditService = {
  list(filters: AuditEventFilters = {}): Promise<AuditEventsResponse> {
    return api.get<AuditEventsResponse>(`/v1/audit/events${queryString(filters)}`);
  },
};
